import { IDefineCommand, IQueryMediator } from 'core-ts-types';
import { APIntakeSurveyNKHelper } from '../../preview_plan/helpers/intake_survey_nk_helper';
import { IInTakeSurveyAnswersDatasource } from '../datasources/intake_survey_answers_datasource';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadInTakeSurveyAnswerCommand',
    function loadInTakeSurveyAnswerCommand(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngIntakeSurveyAnswersDatasource: IInTakeSurveyAnswersDatasource,
      ngAPIntakeSurveyNKHelper: APIntakeSurveyNKHelper,
      appConfigModel: any,
      log: any,
      InTakeSurveyConstants: any
    ) {
      return defineCommand('loadInTakeSurveyAnswerCommand', (deferred) => {
        const nkForIntakeSurvey = ngAPIntakeSurveyNKHelper.intakeSurveyNK;
        $http
          .get(`poll/${nkForIntakeSurvey}/answer`)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngIntakeSurveyAnswersDatasource.clear().write(data.answer);

            deferred.resolve(data);
          })
          .catch((e: string) => {
            log.issue('loadInTakeSurveyAnswerCommand failed');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/commands/load_ap_intake_survey_answer_command.ts